import React from "react";
import { createNumberMask } from "text-mask-addons";
import { string } from "yup";
import Input from "./Base";
import InputMaskWithRef from "./InputMaskWithRef";
const incomeMask = createNumberMask({ prefix: "$" });
export const schema = string().required("An income amount is required.").test("income amount", "Income must be at or above $5,100", (value) => {
  return Number(value.replace(/[$,]/g, "")) >= 5100;
});
export default React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(Input, {
  ref,
  label: "Income",
  InputComponent: InputMaskWithRef,
  required: true,
  mask: incomeMask,
  inputMode: "numeric",
  ...props
}));
